export default __webpack_public_path__ + "static/media/check-icon-white.73d039b3.svg";